import React, { useEffect, useState, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import WidgetMap from "./WidgetMap.js";

import { useDevice } from "../../../hook/userDevice.js"

const WidgetWrapperMapReadings = ({ deviceId }) => {

  const { data: device, isLoading, error } = useDevice(deviceId);
  const [mapData, setMapData] = useState(null);

  // store the zoom level for the re-rendering of the map
  const zoomLevelRef = useRef(14);
  const prevMapData = useRef(mapData);

  useEffect(() => {
    if (!device || !device.location) {
      setMapData(null);
      return;
    }
    console.log('device:', device);

    const [lat, lng] = device.location;

    setMapData({
      id: device.id,
      name: device.name,
      lat,
      lng,
    });
  }, [device]);


  /**
   * Generates a message for when no device is selected or the reading is unavailable.
   *
   * @returns {string} The message string to be displayed when no data is available.
  */
  const getEmptySentence = () => {
    return "Select device to view map...";
  };

  /**
   * Generates a message when the device has no data for the selected keys and timespan.
   *
   * @returns {string} The message string to be displayed when no data is available.
   */
  const getDeviceDataEmptySentence = () => {
    return `Device ${device?.name} has no location data`;;
  };  

  /**
   * Renders the readings or an appropriate message depending on the available data.
   *
   * @param {Array|null} readings - The fetched sensor readings data.
   */
  const memoizedDisplayReadings = useMemo(() => {

    if (!device?.name) {
      prevMapData.current = { lat: null, lng: null };
      return (
        <div className="widget-text-empty">
          {getEmptySentence()}
          </div>
      );
    }
    if (!mapData) {
      return <div className="widget-text-empty">{getDeviceDataEmptySentence()}</div>;
    }
    
    const prev = prevMapData?.current;
    const currentLatLng = { lat: mapData?.lat, lng: mapData?.lng };
    const isNewData  = !prev ||prev.lat !== currentLatLng.lat ||prev.lng !== currentLatLng.lng;

    if (isNewData) {
      prevMapData.current = currentLatLng;
    }

    return <WidgetMap data={mapData} zoomLevelRef={zoomLevelRef} isNewData={isNewData} />;
    
  }, [device, mapData?.lat, mapData?.lng]);

  // Return the rendered widget with the displayed readings or an empty message.
  return <div>{memoizedDisplayReadings}</div>;

};


WidgetWrapperMapReadings.propTypes = {
  deviceId: PropTypes.string.isRequired
};

export default WidgetWrapperMapReadings;